module.exports = __webpack_public_path__ + "img/online_payments.758803a7.png";